export const GOOPTER_EMAIL = "info@goopter.com";
export const GOOPTER_PHONE = "778-379-7918";